export default "__VITE_ASSET__ebf55f2e__"